import { useQuery } from 'react-query';
import { axios } from 'lib';

export const getDcID = async (companyID, dId) => {
  const {
    data: { dcID },
  } = await axios.get(`/api/companies/${companyID}/directs/${dId}`);

  return dcID;
};

export const useCompanyDcID = (companyID, dId, options) => {
    return useQuery(['dc-id', companyID, dId], () => getDcID(companyID, dId), options);
}
